import axios from 'axios'
import {getENV,getParamsFromUrl} from "./utils";
import {HOSID} from "./config"
import {openidCache} from "./cache";
import weuijs from "weui.js"

export default (service, options, loading = '加载中...') => {
  options = Object.assign({}, options);

  options.openId = openidCache.get()

  let _query = getParamsFromUrl(location.href).query || {}; //获取浏览器地址参数

  options.hosId = _query.hosId || HOSID; //医院id

  let env = getENV(),
    url = `//${env.api_hcrm}${service}`;
  let load, config = {}

  Log("service==>", service);
  if (loading) {
    load = weuijs.loading(loading);
  }
  return new Promise((resolve, reject) => {
    axios.post(url, options, config).then((res) => {
      if (loading) {
        load.hide();
      }
      if (res.status == 200) {
        Log('<==service-' + service, res.data);
        resolve(res.data);
      } else {

      }
    }).catch((error) => {
      if (loading) {
        load.hide();
      }
      let data = error.response.data;
      reject(data);
      console.log('error', error);
    });
  })
}



// WEBPACK FOOTER //
// ./src/lib/httpHcrm.js